module.exports = __webpack_public_path__ + "static/media/Adviesbox_INS.cc7373e2.png";